<template>
  <div>
    <Mainlayout></Mainlayout>
    <div class="c-app flex-row align-items-center">
      <CContainer>
        <div class="container-box">
          <div class="text-center">
            <img
              style="max-width: -webkit-fill-available; max-height: 250px"
              src="../assets/img/icon/vectorset.svg"
            />
            <h3 class="title mt-4">Congratulations!</h3>
            <h4 class="sub-title-header">
              <br />
              <span class="custom-score"> {{ qSummary.Percentage }} % </span
              ><br /><br />
              You get an
              <span v-if="qSummary.Percentage > 93">A +</span>
              <span
                v-else-if="qSummary.Percentage > 89 && qSummary.Percentage < 93"
                >A -</span
              >
              <span
                v-else-if="
                  qSummary.Percentage > 87 && qSummary.Percentage < 88.9
                "
                >B +</span
              >
              <span
                v-else-if="
                  qSummary.Percentage > 83 && qSummary.Percentage < 86.9
                "
                >B</span
              >
              <span
                v-else-if="
                  qSummary.Percentage > 79 && qSummary.Percentage < 82.9
                "
                >B -</span
              >
              <span
                v-else-if="
                  qSummary.Percentage > 77 && qSummary.Percentage < 78.9
                "
                >C +</span
              >
              <span
                v-else-if="
                  qSummary.Percentage > 73 && qSummary.Percentage < 76.9
                "
                >C</span
              >
              <span
                v-else-if="
                  qSummary.Percentage > 69 && qSummary.Percentage < 72.9
                "
                >C -</span
              >
              <span
                v-else-if="
                  qSummary.Percentage > 67 && qSummary.Percentage < 68.9
                "
                >D +</span
              >
              <span
                v-else-if="
                  qSummary.Percentage > 60 && qSummary.Percentage < 66.9
                "
                >D</span
              >
              <span v-else>E</span>
            </h4>
            <label class="text-white"
              >Now let’s see your results and rankings with other students. Your comprehensive results will be sent to your email.
            </label>
            <br /><br />
            <span
              v-if="
                check.StartDateAnswer !== ''"
              class="text-white"
            >
              Your result will be displayed on start
              {{ check.StartDateAnswer }} and end on {{ check.EndDateAnswer }}.
              <strong style="font-weight: 700"
                >Please click Save This Link</strong
              >
              <CButton color="primary" @click="copyLinkCurrent" class="m-2">{{
                messageCurrent
              }}</CButton>
              to view your answer once available. <br />
            </span>
            <div class="">
              <CButton
                v-if="
                  check.StartDateAnswer !== '' &&
                  currentDate > check.StartDateAnswer &&
                  currentDate < check.EndDateAnswer
                "
                color="info"
                class="custom-btn-login-active mt-5"
                @click="GoViewResult()"
              >
                View Result
              </CButton>
              <CButton
                v-else-if="check.StartDateAnswer === ''"
                color="info"
                class="custom-btn-login-active mt-5"
                @click="GoViewResult()"
              >
                View Result
              </CButton>

              <CButton
                v-else
                color="info"
                class="custom-btn-login-active mt-5"
                disabled
              >
                View Result
              </CButton>
              <br />
              <CButton
                color="info"
                class="custom-btn-login-active mt-2"
                @click="GoLeaderBoard()"
              >
                View Leaderboard</CButton
              >
              <CButton
                style="max-width: 100%"
                color="info"
                class="custom-btn-login-active mt-2"
                @click="copyLink"
                >{{ messageExam }}</CButton
              >
              <CButton
                style="max-width: 100%"
                color="info"
                class="custom-btn-login-active mt-2"
                id="whatsapp-mobile"
                @click="GoToApp"
                >Share to Whatsapp
              </CButton>
              <br />
              <CButton
                style="max-width: 100%"
                color="info"
                class="custom-btn-login-active mt-2"
                id="whatsapp-desktop"
                @click="GoToWebs"
                >Share to Whatsapp
              </CButton>
            </div>
          </div>
          <br /><br />
        </div>
      </CContainer>
      <!-- <div class="header-top">Quiz</div>
      <div class="header-left">
        <img src="../assets/img/icon/VectorLeft.svg" @click="GoBack()"/>
      </div>
      <div class="header-right">
        <span @click="GoHomePage()"><CIcon name="cil-home"/></span>
        <br />
        
      </div> -->
      <div style="clear: both"></div>
    </div>
  </div>
</template>
  
  <script>
import Vue from "vue";
import Mainlayout from "../containers/TheHeaderLeaderboard.vue";
import { cilCheckCircle } from "@coreui/icons";
export default {
  data: function () {
    return {
      user: {},
      quiz: {},
      qSummary: {},
      check: {},
      currentDate: `${new Date().toLocaleDateString(
        "en-GB"
      )} ${new Date().toLocaleTimeString("en-GB")}`,
      studentProfileAuthorize: "",

      startDate: "", // Add the startDate property
      endDate: "", // Add the endDate property

      linkShare:
        "https://app.pickiddo.com/v3/#/ExamDetail?guidId=" +
        this.$route.query.guidId,
      messageExam: "Share Exam by link",
      messageCurrent: "Save this link",
    };
  },
  components: {
    Mainlayout,
  },
  async mounted() {
    this.GetStudentFinalScore();
    this.GetDateShowAnswer();
  },
  methods: {
    GoHomePage() {
      this.$router.push("/ExistingUser");
    },

    async GetStudentFinalScore() {
      this.$API
        .get(
          this.$GetStudentFinalScoreExam +
            "?startId=" +
            this.$route.query.startId
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.qSummary = response.data;
          }
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    async GetDateShowAnswer() {
      this.$API
        .get(this.$GetDateShowAnswer + "?guidId=" + this.$route.query.guidId)
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.check = response.data;
          }
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    isInDateRange() {
      if (this.check.StartDateAnswer && this.check.EndDateAnswer) {
        const currentDate = `${new Date().toLocaleDateString(
          "en-GB"
        )} ${new Date().toLocaleTimeString("en-GB")}`; // Get the current date and time
        console.log("curr" + currentDate);
        console.log("start" + this.check.StartDateAnswer);
        console.log("end" + this.check.EndDateAnswer);

        const startDate = new Date(this.check.StartDateAnswer); // Convert the start date and time to a Date object
        const endDate = new Date(this.check.EndDateAnswer); // Convert the end date and time to a Date object

        // Check if the current date and time is within the range
        return currentDate >= startDate && currentDate <= endDate;
      }
      return false;
    },
    GoLeaderBoard() {
      this.$router.push("ExamLeaderboard?guidId=" + this.$route.query.guidId + "&startId=" +
          this.$route.query.startId);
    },
    GoViewResult() {
      this.$router.push(
        "ExamPreview?guidId=" +
          this.$route.query.guidId +
          "&startId=" +
          this.$route.query.startId
      );
    },
    shareOnWhatsApp() {
      const message = encodeURIComponent("Check out this link!");
      const shareUrl = `https://web.whatsapp.com/send?text=${message}%20${this.linkShare}`;
      const isWhatsAppInstalled = this.isAppInstalled("whatsapp");

      if (isWhatsAppInstalled) {
        window.location.href = `whatsapp://send?text=${message}%20${this.linkShare}`;
      } else {
        window.open(shareUrl);
      }
    },

    isAppInstalled(scheme) {
      const regex = new RegExp(`${scheme}:`);
      return regex.test(window.navigator.userAgent.toLowerCase());
    },
    copyLink() {
      this.messageExam = "Copied";
      navigator.clipboard.writeText(this.linkShare);
    },
    copyLinkCurrent() {
      this.messageCurrent = "Copied";
      const currentUrl = window.location.href;
      navigator.clipboard.writeText(currentUrl);
    },
    GoToApp() {
      const myParamValue = this.$route.query.guidId;
      const encodedParamValue = encodeURIComponent(myParamValue);
      //const url = `https://example.com/my-page?myParam=${encodedParamValue}`;
      console.log("test" + myParamValue);

      window.open(
        `whatsapp://send?text=Check out this message https://app.pickiddo.com/v3/%23/ExamDetail?guidId%3D${encodedParamValue}`
      );
    },
    GoToWebs() {
      var linkshares = this.linkShare;
      window.open(
        `https://web.whatsapp.com/send?text=Check out this message%20${this.linkShare}`
      );
    },
  },
};
</script>
  
  <style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
body {
  font-family: "Montserrat", sans-serif;
}
.container-box {
  max-width: 335px;
  margin: 0 auto;
}

@media only screen and (max-width: 768px) {
  #whatsapp-mobile {
    display: block;
  }
  #whatsapp-desktop {
    display: none;
  }
}
@media only screen and (min-width: 769px) {
  #whatsapp-mobile {
    display: none;
  }
  #whatsapp-desktop {
    display: block;
  }
}
</style>